#import "~/graphql/fragments/Components/CraftLink.graphql"
#import "~/graphql/fragments/Assets/MenuOverlayImageAsset.graphql"

fragment NavigationMenuLinks on navigation_Entry {
    primaryMenuTitle
    primaryMenu {
        ...on primaryMenu_link_BlockType {
            menuLink {
                ...CraftLinkField
            }
            image {
                ...MenuOverlayImageAsset
            }
        }
    }

    secondaryMenuTitle
    locationsMenu {
        ...on locationsMenu_link_BlockType {
            menuLink {
                ...CraftLinkField
            }
            image {
                ...MenuOverlayImageAsset
            }
            label
            children {
                ... on locationsMenu_subitem_BlockType {
                    menuLink {
                        ...CraftLinkField
                    }
                    image {
                        ...MenuOverlayImageAsset
                    }
                }
            }
        }
    }

    secondaryMenu {
        ... on secondaryMenu_link_BlockType {
            menuLink {
                ...CraftLinkField
            }
        }
    }
}
